import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  content: {
    hero_headline: "Control the Asset. Control the Capital. Control the Opportunity.",
    hero_subheadline:
      "Moaglee is a private business ecosystem for owners, investors, operators, and entrepreneurs using commercial real estate, capital, media, and intelligent systems to create leverage.",
    primary_cta: "Book a Strategy Call",
    secondary_cta: "Join the Private Network",
    contact_email: "support@moaglee.com",
  },
  redirects: {
    capital: "https://MoagleeCapital.com",
    media: "https://MoagleeMedia.com",
    cre: "https://MoagleeCRE.com",
    aspire: "https://AspirePerspireInspire.com",
    book_call: "https://calendly.com/moaglee/bot-intake-form",
  },
  calendar: {
    strategy_call: "https://calendly.com/moaglee/bot-intake-form",
  },
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext) || { settings: FALLBACK };
}
